<template>
  <div class="container-table">
    <table class="table table-bordered table-hover tab-previous-donations table-full-screen">
      <thead>
      <tr class="adapt-tr adapt-tr-head">
        <th
            scope="col"
            class="adapt-th"
            v-for="(itemArrCreateTab, indexArrCreateTab) in arrCreateTab"
            :key="indexArrCreateTab"
        >
          {{ itemArrCreateTab.label }}
        </th>
      </tr>
      </thead>
      <tbody
          v-for="(itemPreviousDonations, indexPreviousDonations) in previousDonations.slice(startArr,lengthArr)"
          :key="indexPreviousDonations"
      >
        <tr>
          <td
              class="adapt-td adapt-donations_"
              v-for="(itemArrCreateTab, indexArrCreateTab, index) in arrCreateTab"
              :key="indexArrCreateTab"
          >
            <div style="display: flex; justify-content: space-between; padding: 12px 5px 12px 12px;">
              {{ itemPreviousDonations[itemArrCreateTab.name] }}
              <span
                class="test-span"
                v-if = "itemPreviousDonations.donationTestsExists===true && index === 0"
              >
                View Test Results
                <font-awesome-icon :icon="['fas', 'chevron-circle-down']"
                  class="test-icon"
                  v-if="!expandTests.iconExpandTests===true"
                 @click="showTests(indexPreviousDonations)"
                />
                <font-awesome-icon :icon="['fas', 'chevron-circle-up']"
                  class="test-icon"
                  v-else
                  @click="hideTests"
                />
              </span>
            </div>
          </td>
        </tr>
        <tr v-if="expandTests.expandTests===true
              && itemPreviousDonations.donationTestsExists
              && expandTests.index === indexPreviousDonations"
        >
          <td :colspan="getArrCreateTabLength()">
            <div style="font-weight: 700; font-size: 18px;">Tests</div>
            <div>
              <table class="chaild-tab table-full-screen tab-previous-donations tab-tests">
                <thead>
                <tr class="donation-tr">
                  <td
                      class="donation-td"
                      v-for="(itemTestDonorDonation, indexTestDonorDonation) in itemPreviousDonations.donationTests[0]"
                      :key="indexTestDonorDonation"
                  >
                    {{ itemTestDonorDonation.label }}
                  </td>
                </tr>
                </thead>
                <tbody class="donation-tboby">
                <tr class="donation-tr"
                    v-for="(itemTestDonorDonation, indexTestDonorDonation) in itemPreviousDonations.donationTests"
                    :key="indexTestDonorDonation">

                  <td
                      class="donation-td"
                      v-for="(itemValTestDonorDonation, indexValTestDonorDonation) in itemTestDonorDonation"
                      :key="indexValTestDonorDonation"
                  >
                    {{ itemValTestDonorDonation.value }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
      </tbody>
    </table>

    <table
        class="table table-bordered table-hover tab-previous-donations table-small-screen"
        style="margin-bottom: 0"
        v-for="(itemPreviousDonations, indexPreviousDonations) in previousDonations.slice(startArr,lengthArr)"
        :key="indexPreviousDonations"
    >
      <tbody
          v-for="(itemArrCreateTab, indexArrCreateTab, index) in arrCreateTab"
          :key="indexArrCreateTab"
      >
      <tr class="donation-tr donation-tr-first">
        <td class="donation-td" style="padding: 0">
          <div class="small-screen-name-col">
            {{ itemArrCreateTab.label }}
            <span
              class="test-span"
              v-if = "itemPreviousDonations.donationTestsExists===true && index === 0"
            >
              View Test Results
              <font-awesome-icon :icon="['fas', 'chevron-circle-down']"
                 class="test-icon"
                 v-if="!expandTests.iconExpandTests===true"
                 @click="showTests(indexPreviousDonations)"
              />
              <font-awesome-icon :icon="['fas', 'chevron-circle-up']"
                 class="test-icon"
                 v-else
                 @click="hideTests"
              />
            </span>
          </div>
        </td>
        <td class="donation-td">
          {{ itemPreviousDonations[itemArrCreateTab.name] }}
        </td>
      </tr>
      <tr
          class="tr-donation-test donation-tr "
          v-if="expandTests.expandTests===true
            && Array.isArray(itemPreviousDonations.donationTests)
            && expandTests.index === indexPreviousDonations"
      >
        <td class="td-donation-test donation-td" colspan="2" >
          <div style="font-weight: 700; font-size: 18px;">Tests</div>
          <div>
            <table class="chaild-tab table-small-screen tab-previous-donations tab-tests">
              <tbody
                  class="donation-tboby"
                  v-for="(itemTestDonorDonation, indexTestDonorDonation) in itemPreviousDonations.donationTests"
                  :key="indexTestDonorDonation"
              >

              <tr><td>Test</td></tr>

              <tr
                  class="donation-tr"
                  v-for="(itemValTestDonorDonation, indexValTestDonorDonation) in itemTestDonorDonation"
                  :key="indexValTestDonorDonation"
              >
                <td class="donation-td">
                  {{ itemValTestDonorDonation.label }}
                </td>
                <td class="donation-td">
                  {{ itemValTestDonorDonation.value }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "previousDonationTab",
  props: [ 'previousDonations', 'slice' ],
  computed: {
    ...mapState({
      arrCreateTab: state => state.settingsAndCustomize.siteCustomizationData.previousDonations.arrCreateTab,
    }),
    lengthArr: function() {
      let result = ''
      switch (this.slice){
        case 'all': result = this.previousDonations.length; break
        case 'short': result = 6; break
        case 'resentDonation': result = 1; break
      }
      return result
    },
    startArr: function () {
      let result = ''
      switch (this.slice){
        case 'all': result = 1; break
        case 'short': result = 1; break
        case 'resentDonation': result = 0; break
      }
      return result
    }
  },
  data(){
    return {
      expandTests: {
        iconExpandTests: false,
        expandTests: false,
        index: '',

      },
    }
  },
  methods: {
    getArrCreateTabLength() {
      return Object.keys(this.arrCreateTab).length
    },
    hideTests(){
      this.expandTests.iconExpandTests = false
      this.expandTests.expandTests = false
      this.expandTests.index = ''
    },
    showTests(index){
      this.expandTests.iconExpandTests = true
      this.expandTests.expandTests = true
      this.expandTests.index = index
    },
  }
}
</script>

<style scoped>
  .test-span{
    display:flex;
    margin-left:10px;
    text-transform:uppercase;
    font-weight:bold;
    cursor:pointer;
  }
  .test-icon{
    margin-left: 5px;
  }
  .table-full-screen td, .table-small-screen td, .table-full-screen th, .table-small-screen th{
    vertical-align: middle;
  }
  .tab-tests{
    width: 100%;
  }
  .tab-tests thead, .tab-tests tbody, .tab-tests tfoot, .tab-tests tr, .tab-tests td, .tab-tests th {
    padding: 0.5rem 0.5rem;
    border-color: rgb(222, 226, 230);
    border-style: solid;
    border-width: 1px;
  }
  .table-small-screen{
    display: none;
  }
  .table-full-screen{
    width: 100%;
  }
  .small-screen-name-col{
    display: flex!important;
    justify-content: space-between;
    padding: 12px 5px 12px 12px;
    margin-left: 0;
  }
  @media (max-width: 767.98px) {
    .table-small-screen{
      display: table;
      width: 100%;
      table-layout: fixed;
    }
    .table-full-screen{
      display: none!important;
    }
  }
</style>